
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1280 893","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"app-inline-svg",attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12 20h400v317H12zM12 346h186v44H12zM12 399h400v25H12zM12 433h141v25H12zM359 488h53v21h-53zM293 488h53v21h-53zM227 488h53v21h-53zM452 20h400v190H452zM452 219h186v44H452zM452 272h400v25H452zM452 306h141v25H452zM799 361h53v21h-53zM733 361h53v21h-53zM667 361h53v21h-53zM12 551h400v190H12zM12 750h186v44H12zM12 803h400v25H12zM12 837h141v25H12zM359 892h53v21h-53zM293 892h53v21h-53zM227 892h53v21h-53zM452 451h400v190H452zM452 650h186v44H452zM452 703h400v25H452zM452 737h141v25H452zM799 792h53v21h-53zM733 792h53v21h-53zM667 792h53v21h-53zM892 20h400v397H892zM892 426h186v44H892zM892 479h400v25H892zM892 513h141v25H892zM1239 568h53v21h-53zM1173 568h53v21h-53zM1107 568h53v21h-53z"}})])])
          )
        }
      }
    